// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__26_Vc","rightAdornment":"Header_rightAdornment__LSPS9"};